import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { TabularSinkAdapter } from 'app/model/adapters/activities/copysink/tabular.sink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { OdbcSink } from 'app/model/pipeline/copysink/odbc.copysink';
import { CopySinkAdapter } from './copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OdbcSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchTimeout: '*',
        writeBatchSize: '*',
        preCopyScript: '*',
        maxConcurrentConnections: '*',
        structure: '*'
    }
})
export class OdbcSinkAdapter extends CopySinkAdapter<OdbcSink, Model.OdbcSink> {
    protected override async _toResource(model: OdbcSink): Promise<Model.OdbcSink> {
        const result: Model.OdbcSink = {
            type: 'OdbcSink'
        };
        TabularSinkAdapter.toSinkResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.OdbcSink, owner: Activity): Promise<OdbcSink> {
        const result = Owned.create<OdbcSink>(Metamodel.modelFor(OdbcSink), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
